import request from './base'

export const getRtkInfo = (params) => {
    return request.post('/admin/v1/tools/getRtkInfo', params)
}

export const queryRtkByVin = (params) => {
    return request.post('/admin/v1/rtk/queryByVin', params)
}

export const autobindRtkByVin = (params) => {
    return request.post('/admin/v1/rtk/autobindByVin', params)
}

export const activateRtkByVin = (params) => {
    return request.post('/admin/v1/rtk/activateByVin', params)
}




// WEBPACK FOOTER //
// ./src/api/rtk.js